import {Box, Stack, Tab, Tabs, useTheme} from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import {GetTheme, THEME} from '../../theme/customThemeProvider';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            style={{
                width: '100%'
            }}
            {...other}
            >
                {value === index && (
                    <Box 
                        sx={{ 
                            pl: 3,
                            width: '100%',
                        }}
                    >
                        {children}
                    </Box>
                )}
        </div>
    );
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const SideNavigationComponent = ({
    list,
    manualIndex=0,
    customChangeFunction=null,
    tabsSx
}) => {
    const theme = useTheme();
    const {themeMode} = GetTheme();

    const [value, setValue] = useState(manualIndex);

    const handleChange = useCallback((event, newValue) => {
        setValue(newValue);

        if(customChangeFunction){
            customChangeFunction(newValue);
        }
    }, [customChangeFunction]);

    useEffect(() => {
        setValue(manualIndex);
    }, [manualIndex]);

    return (
        <>
            <Box
                sx={{ 
                    flexGrow: 1, 
                    display: 'flex'
                }}
            >
                <Tabs
                    orientation="vertical"
                    variant="scrollable"
                    value={value}
                    onChange={handleChange}
                    aria-label="Vertical tabs example"
                    sx={{ 
                        borderRight: 1, 
                        borderColor: 'divider', 
                        pr: 2,
                        ...tabsSx
                    }}
                    indicatorColor='transparent'
                >
                    {
                        list.map((item, index) => {
                            return <Tab 
                                key={index}
                                label={item.label} 
                                {...a11yProps(index)}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    fontSize: {xs: 12, md: 14, lg: 16},
                                    lineHeight: 1.5,
                                    backgroundColor: value === index ? theme.palette.primary.main : theme.palette.background.paper,
                                    borderRadius: 8,
                                    px: 3,
                                    my: {xs: 1, md: 2},
                                    '&.Mui-selected': {
                                        color: theme.palette.primary.contrastText
                                    },
                                    '&: hover': {
                                        transform: 'scale(0.9)'
                                    }
                                }}
                            />
                        })
                    }
                </Tabs>

                {
                    list.map((item, index) => {
                        return <TabPanel 
                            key={index}
                            value={value} 
                            index={index}
                        >
                            {item.children}
                        </TabPanel>
                    })
                }
            </Box>
        </>
    );
}

export default SideNavigationComponent;